import React from 'react';
import { Helmet } from "react-helmet";
import './style.css';
import Footer from 'components/Footer/Footer';
import StoryTeller from 'components/StoryTeller/StoryTeller';
import hostimg from 'Assets/storyimg2.png';
import recordimg from 'Assets/storyimg1.png';
import publishimg from 'Assets/publish@2x.jpg';
import home from 'Assets/home.svg';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "components/Button/Button";
import { org_friendly_url, apiUrl, HeaderConfig, managed_contents, user_Status } from 'Api/Api';
import axios from 'axios';
import PkCreateBanner from 'components/Banner/PkCreatebanner';
//import footerBanner from 'Assets/footer-pk-hero.png';
import footerBanner from 'Assets/footer-banner@2x.jpg';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import SpotLightPk from 'components/spotlightedPK/spotlightedPK';
import { local_routes } from 'utils/Routes';

class PkCreateHome extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      managedContentsHtmlSectionOne: {},
      managedContentsHtmlSectionTwo: {},
      managedContentsHtmlSectionThree: {},
      pageLoader: true,
      spotlighted_pk_info: {},
      spotlighted_pk_user_info: {}
    }

    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
    
    this.presentation_relative_url = 'presentations/how-to-make-a-presentation-with-pechakucha-create';
    
  }
  componentDidMount = async function () {
    window.scrollTo(0, 0);
    let [managed_contentsOtherDataRes,spotlighted_pk_response,spotlighted_pk_users_response] = await Promise.all([
      axios.get(`${managed_contents}/pkcreate`, HeaderConfig),
      axios.get(`${apiUrl}${this.presentation_relative_url}`), // hard-coded for now
      axios.get(`${apiUrl}${this.presentation_relative_url}/users?filter_obj=${encodeURIComponent('{"presenter_integer":{"gte":1}}')}`) // hard-coded for now
    ]);
      
    // Other section data like banner, Pechakucha is all about etc,...
    console.log(managed_contentsOtherDataRes)
    if (managed_contentsOtherDataRes) {
      this.setState({
        managedContentsHtml: managed_contentsOtherDataRes.data,
        managedContentsHtmlSectionOne: managed_contentsOtherDataRes.data.content_sections.section_01,
        managedContentsHtmlSectionTwo: managed_contentsOtherDataRes.data.content_sections.section_02,
        managedContentsHtmlSectionThree: managed_contentsOtherDataRes.data.content_sections.section_03,
      })
      this.setState({ pageLoader: false, })
    }
    
    let tmp_spotlighted_pk_info = {};
    if (spotlighted_pk_response.data) {
      this.setState({ spotlighted_pk_info: spotlighted_pk_response.data });
    }
    if (spotlighted_pk_users_response.data && spotlighted_pk_users_response.data.length > 0) {
      let tmp_pk_user_info = spotlighted_pk_users_response.data[0];
      //console.log("YO",tmp_pk_user_info);
      this.setState({ spotlighted_pk_user_info: tmp_pk_user_info });
    }
  }

  noUser=()=>{
    window.localStorage.setItem('loginOrigin', "pkCreation");
  }

  handleClickLike = () => {
    console.log("handleClickLike donothing");
  }

  render() {
    const { managedContentsHtmlSectionOne,pageLoader } = this.state;
    const guestHomeHead = { backgroundImage: `url(${managedContentsHtmlSectionOne.image_url})`, };
    const spaceStyles = { marginLeft: 0, marginRight: 0 };
    const footerBannerImg = { backgroundImage: `url(${footerBanner})` }
    if (pageLoader) {
            return (
                <FullPageSpinner />
            )
        }
        else {
    return (
      <React.Fragment>
        <Helmet>
          <title>PK Create PechaKucha Presentation Software</title>
          <meta name="description" content="PK Create is presentation software that makes it easy to make Pecha Kucha presentations. Sign up for your free Pecha Kucha account." />
        </Helmet>
        <div className="Schools">
          {/* Banner Starts */}
          {
            managedContentsHtmlSectionOne ?
              <Row style={spaceStyles}>
                <section className="pk-guesthome-head" style={guestHomeHead}>
                  <div className="container">
                    <div className="row">
                      <Col sm={12} md={12} lg={8}>
                        <div className="guest-btn">
                          <h1>{managedContentsHtmlSectionOne.title}<span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> BETA</span></h1>
                          <div className="guesthome-content">
                            <p dangerouslySetInnerHTML={{ __html: managedContentsHtmlSectionOne.html_content }}></p>
                          </div>
                          {user_Status === 1 ?
                            <a href={local_routes.pkcreation} className="btn-start-color">
                              <Button theme="btn-global btn-hover btn-green btn-fit">
                                Get Started</Button></a>
                            :
                            <a href="/login" className="btn-start-color">
                              <Button  OnClickMet={()=>this.noUser()} theme="btn-global btn-hover btn-green btn-fit">
                               Get Started</Button></a>
                          }
                        </div>
                      </Col>
                    </div>
                  </div>
                </section>
              </Row>
              : null
          }
          {/* Banner Section ends */}

          {/* Story Teller Section starts */}
          <div className="pk-create-blog">
            <StoryTeller
              hostImage={hostimg}
              recordImage={recordimg}
              presentationImage={publishimg}
              StoryHead="Storytelling made easy"
              StorySubHead="PechaKucha makes telling a story as easy as 1-2-3"
              UploadData="Upload Images"
              UploadDataDescription="Drag and drop or upload images in any order."
              RecordData="Record Audio"
              RecordDataDescription="Practice your presentation before or record it live in your browser.No plugins needed."
              AccessData="Publish PK Presentation"
              AccessDataDescription="Let the world hear your story"
            />
          </div>
          
          {
              this.state.spotlighted_pk_info.presentation_video_url !== undefined &&
              <SpotLightPk
                city_or_channel_name={this.state.spotlighted_pk_info.entity_name}
                presentation_data={this.state.spotlighted_pk_info}
                entity_name={this.state.spotlighted_pk_info.entity_name}
                avatar_image_url={this.state.spotlighted_pk_user_info.avatar_image_url}
                firstName={this.state.spotlighted_pk_user_info.firstname}
                lastName={this.state.spotlighted_pk_user_info.lastname}
                designation={this.state.spotlighted_pk_user_info['description']}
                full_name={''}
                presenter_friendly_url={this.state.spotlighted_pk_user_info.friendly_url}
                friendly_url={this.state.spotlighted_pk_info.friendly_url}
                // eslint-disable-next-line
                //designation={presentationData['description']}
                description={this.state.spotlighted_pk_info['description']}
                mailTo="mailto:support@pechakucha.org"
                textReport=""
                iconName="fa fa-flag"
                iconNameLike="fa fa-heart"
                noOfLikes={this.state.spotlighted_pk_info.applaud_count}
                handleClick={this.handleClickLike}
                likeLabel={'like'}
                likeLoader={false}
                workspace_base_url={this.workspace_base_url}
              />
            }
          
          
          {/* Footer Banner Section */}
          
          <PkCreateBanner
            footerBannerImg={footerBannerImg}
            pkCreateFooterHeading="Engage and inspire your audience through concise visual storytelling"
            schoolsBtn="PK for Schools" businessBtn="PK for Business" hostAnEventBtn="Host an Event"
          />
          
          {/* Footer Banner Ends Section */}
          {/* Story teller section ends */}
          <div className="pk-create-footer">
            <Footer
              homeImg={home}
              homeImgRef="/"
              breadcrumbSubPage="PK Create"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
  }
}

export default PkCreateHome;
